/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCaseDetails
 */
export interface InternalApiCaseDetails {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseDetails
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseDetails
     */
    rationaleCode: string;
}

/**
 * Check if a given object implements the InternalApiCaseDetails interface.
 */
export function instanceOfInternalApiCaseDetails(value: object): value is InternalApiCaseDetails {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rationaleCode' in value) || value['rationaleCode'] === undefined) return false;
    return true;
}

export function InternalApiCaseDetailsFromJSON(json: any): InternalApiCaseDetails {
    return InternalApiCaseDetailsFromJSONTyped(json, false);
}

export function InternalApiCaseDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rationaleCode': json['rationaleCode'],
    };
}

export function InternalApiCaseDetailsToJSON(json: any): InternalApiCaseDetails {
    return InternalApiCaseDetailsToJSONTyped(json, false);
}

export function InternalApiCaseDetailsToJSONTyped(value?: InternalApiCaseDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'rationaleCode': value['rationaleCode'],
    };
}

